import { render, staticRenderFns } from "./cc.vue?vue&type=template&id=2830f115&scoped=true&"
import script from "./cc.vue?vue&type=script&lang=js&"
export * from "./cc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830f115",
  null
  
)

export default component.exports